export default __webpack_public_path__ + "static/media/chk-white.d660606c.svg";